import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { getFeatureFlagDefaults } from '../config/featureFlags';
const PassThrough = ({ children }) => _jsx(_Fragment, { children: children });
// When enabled, the app reads flags from LaunchDarkly at runtime via streaming
// connection. Flag changes synced by GitHub Actions are picked up instantly — no
// redeploy needed.
// When disabled (local dev, tests), the webpack alias resolves
// launchdarkly-react-client-sdk to src/shims/, whose useFlags() returns
// environment-specific defaults from feature-flags/*.json via getFeatureFlagDefaults().
// Source of truth: feature-flags/feature-flags-core.json (synced to LaunchDarkly)
// Environment overrides: feature-flags/feature-flags-{dev-dit,e2e,prod}.json
//
// Config is injected via docker-entrypoint.sh → window.__ENV (env vars from K8s Secrets)
const LaunchDarklyProvider = ({ children }) => {
    const Provider = useMemo(() => {
        var _a, _b;
        const env = window.__ENV;
        const enabled = (env === null || env === void 0 ? void 0 : env.REACT_APP_LAUNCHDARKLY_ENABLED) === 'true';
        const clientSideID = (_a = env === null || env === void 0 ? void 0 : env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID) !== null && _a !== void 0 ? _a : '';
        if (!enabled || !clientSideID) {
            return PassThrough;
        }
        const envName = (_b = env === null || env === void 0 ? void 0 : env.ENV_NAME) !== null && _b !== void 0 ? _b : 'unknown';
        const defaults = getFeatureFlagDefaults();
        return withLDProvider({
            clientSideID,
            reactOptions: {
                useCamelCaseFlagKeys: false
            },
            context: {
                kind: 'multi',
                environment: {
                    key: envName,
                    name: envName
                }
            },
            options: {
                bootstrap: defaults
            }
        })(PassThrough);
    }, []);
    return _jsx(Provider, { children: children });
};
export default LaunchDarklyProvider;
